export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5368.5ee7edee.jpg";